import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { ConfirmPopup } from '~/commonComponents';
import AnimatedCheckCircle from '~/components/shared/AnimatedCheckCircle';

const SuccessIconComponent = () => <AnimatedCheckCircle />;

interface IRejectCandidateSuccessPopupProps {
  professionalName: string;
  onClose: () => void;
}

export const RejectCandidateSuccessPopup = ({
  onClose,
  professionalName,
}: IRejectCandidateSuccessPopupProps) => (
  <ConfirmPopup
    Icon={SuccessIconComponent}
    title="Candidate Status Successfully Updated"
    titleStyle={{ marginTop: 21, marginBottom: 16 }}
    description={
      <Typography as="span" color={colors.neutral[500]}>
        <Typography as="span" bold color={colors.neutral[500]}>
          {professionalName}
        </Typography>
        ’s application is no longer active and has been
        <br />
        archived under Rejected. Keep reviewing other
        <br />
        applicants to find your next great hire.
      </Typography>
    }
    descriptionStyle={{ width: '100%', marginBottom: 38 }}
    modalStyle={{ width: 560 }}
    rightButtonText="Done"
    rightButtonAction={onClose}
  />
);
